module.exports = __webpack_public_path__ + "static/media/217818F3-D09F-4E05-A53A-CCDA1CE59B7F.71374f66.JPG";